<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="schedule">
            <van-nav-bar
                title="工程进度"
                left-text="合同列表"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <div class="add_btn" v-if="active === 0" @click="addEngineering">
                    <i class="iconfont iconicon-test"></i>
                </div>
                <header>
                    <div class="headerContent">
                        <div class="corporateName">
                            <p class="van_left">
                                {{ detail.client_name }}
                            </p>
                            <span class="van_right">
                                登记时间:{{ detail.signing_date && detail.signing_date.substring(0,10) }}
                            </span>
                        </div>
                        <van-divider></van-divider>
                        <div class="entryName">
                            <p>
                                {{ detail.engineering_name }}
                            </p>
                            <i class="projectObject" v-if="detail.engineering_type_name">{{ detail.engineering_type_name }}</i>
                            <i class="projectImportance">{{ detail.emphasis ? '重点工程' : '一般工程' }}</i>
                        </div>
                        <!-- <van-divider dashed></van-divider> -->
                        <div class="squareQuantity">
                            <div class="iconfont icontijikongjian van_left">
                                预计方量
                                <span class="estimate">
                                    {{ detail.projected_capacity }}m³
                                </span>
                            </div>
                            <div class="iconfont icontijikongjian van_left">
                                已发方量
                                <span class="alreadyUsed">
                                    {{ detail.delivery_total_quantity }}m³
                                </span>
                            </div>
                        </div>
                        <van-divider></van-divider>
                        <div class="remarks">
                            备注：{{ detail.remarks }}
                        </div>
                    </div>
                </header>
                <div class="section-box">
                    <van-tabs v-model="active" @click="onTabClick" animated>
                        <van-tab title="工程进度" class="projectProgress">
                            <div class="engineering-wrapper">
                                <van-steps direction="vertical" v-if="EngineeringList.length > 0">
                                    <van-step v-for="(item,index) in EngineeringList" :key="index">
                                        <h3>
                                            <p class="van_left">
                                                {{ item.created }}
                                            </p>
                                            <span class="van_right">{{ item.creator }}</span>
                                        </h3>
                                        <div class="scheduleContant">
                                            <ul v-if="imgData[index][0]">
                                                <li
                                                    v-for="(jtem,jndex) in imgData[index]"
                                                    :key="jndex"
                                                    @click="imgPreviewClick(imgData[index])"
                                                >
                                                    <img :src="jtem" alt="">
                                                </li>
                                            </ul>
                                            <p>{{ item.visual_progress }}</p>
                                            <span></span>
                                        </div>
                                    </van-step>
                                </van-steps>
                                <div v-else class="no_data">
                                    暂无数据
                                    <!-- <img src="@/assets/images/common/no_data.png" alt=""> -->
                                </div>
                            </div>
                        </van-tab>
                        <van-tab
                            title="单体进度"
                            class="monomerProgress"
                            v-if="detail.engineering_type === '103-FJ0'"
                        >
                            <div class="monomer-wrapper">
                                <ul v-if="EngineeringMonomerList.length > 0">
                                    <li v-for="(item,index) in EngineeringMonomerList" :key="index">
                                        <h3>更新时间：{{ item.progressTime }}</h3>
                                        <div class="info">
                                            <div class="header-name">
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>单体名称:{{ item.monomer_name }}</span>
                                            </div>
                                            <div class="info-box">
                                                <div class="van_left left_text" @click="hanleClick(item)">
                                                    <p>
                                                        <img src="@/assets/images/icons/icon_30.png" alt="">
                                                        <span>预计方量:{{ item.projected_capacity || 0 }}m³</span>
                                                    </p>
                                                    <p>
                                                        <img src="@/assets/images/icons/icon_30.png" alt="">
                                                        <span>供应方量:{{ item.used_capacity || 0 }}m³</span>
                                                    </p>
                                                    <p>
                                                        <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                                        <span>施工楼层/楼层:{{ item.current_floors }}/{{ item.floors }}</span>
                                                    </p>
                                                </div>
                                                <img
                                                    class="van_right right_img"
                                                    v-if="imgDataDt[index]"
                                                    :src="imgFun(imgDataDt[index])"
                                                    alt=""
                                                    @click="imgPreviewClick(imgDataDt[index])"
                                                >
                                                <img
                                                    class="van_right right_img"
                                                    v-else
                                                    src="@/assets/images/home/m_zw.png"
                                                    alt=""
                                                >
                                            </div>
                                        </div>
                                        <van-divider></van-divider>
                                        <van-steps :active="sgActiveChange(item)">
                                            <van-step v-for="(Jtem,Jndex) in sgList" :key="Jndex">
                                                {{ Jtem.name }}
                                            </van-step>
                                        </van-steps>
                                    </li>
                                </ul>
                                <div v-else class="no_data">
                                    暂无数据
                                    <!-- <img src="@/assets/images/common/no_data.png" alt=""> -->
                                </div>
                            </div>
                        </van-tab>
                    </van-tabs>
                </div>
            </section>
            <van-image-preview v-model="imgShow" :images="imagesList" @change="onChange">
                <template v-slot:index>
                    {{ imgIndex }}/{{ imagesList.length }}
                </template>
            </van-image-preview>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 进度
    name: 'schedule',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/contractProgress') {
            this.keywords = '';
            this.$store.commit('noKeepAlive', 'schedule');
        }
        next();
    },
    components: {},
    props: {},
    data() {
        return {
            active: this.$route.params.active || 0, // 当前页面选中的tab对应的index
            imgShow: false, // 控制图片预览开关
            detail: {}, // 上一个页面带过来的合同基本信息
            EngineeringList: [], // 工程进度list
            EngineeringMonomerList: [], // 单体进度list
            imagesList: [], // 需要预览的所有图片集合
            imgIndex: 1, // 预览图片的默认第一张的下标
            sgList: [], // 施工阶段list
            imgData: [],
            imgDataDt: [],
        };
    },
    computed: {},
    watch: {},
    created() {
        this.detail = JSON.parse(JSON.stringify(this.$route.params.obj));
    },
    activated() {
        // 获取工程基本信息
        this.getEngineeringDetails();
        // active 0 执行获取工程进度接口 1 执行获取单体进度接口
        if (this.active === 0) {
            this.getEngineeringList();
        } else {
            this.getEngineeringMonomerList();
        }
        // 获取施工阶段字段list
        this.constructionSelectList();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 获取文件下载预览地址
        getFileDetailFun(imgs, i, key) {
            if (imgs) {
                imgs.split(',').forEach(item => {
                    this[key][i].push(`${this.GLOBAL.FILE_BASE_URL}file-manage/${item}/download`);
                });
            }
        },
        // 获取工程基本信息
        getEngineeringDetails() {
            this.$axios
                .get('/interfaceApi/sale/engineering_manager/get_engineering/' + this.detail.engineering_id)
                .then(res => {
                    this.detail.remarks = res.remarks;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 单体进度图片拼接全路径显示
        imgFun(imgArr) {
            if (imgArr && imgArr.length > 0) {
                return imgArr[0];
            }
            return '';
        },
        // 根据单体列表的施工阶段遍历选中对应的施工阶段
        sgActiveChange(obj) {
            let _index = '';
            this.sgList.map((item, index) => {
                if (item.code === obj.current_progress) {
                    _index = index;
                }
            });
            return _index;
        },
        // 图片预览切换图片索引递增
        onChange(index) {
            this.imgIndex = index + 1;
        },
        // 打开图片预览
        imgPreviewClick(images_data) {
            this.imgShow = true;
            this.imagesList = images_data;

        },
        // 获取施工阶段list字典
        constructionSelectList() {
            this.$axios
                .get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=108&type=1')
                .then(res => {
                    this.sgList = res;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // tab却换
        onTabClick(name) {
            this.active = name;
            if (this.active === 0) {
                this.getEngineeringList();
            } else {
                this.getEngineeringMonomerList();
            }
        },
        // 添加工程页面跳转
        addEngineering() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'addEngineering',
                params: {
                    obj: this.detail,
                    active: this.active,
                },
            });
        },
        // 获取工程进度list
        getEngineeringList() {
            this.$axios
                .get('/interfaceApi/sale/engineering_progress/get_engineering_list/' + this.detail.engineering_id)
                .then(res => {
                    const arr = res;
                    res.forEach(() => {
                        this.imgData.push([]);
                    });
                    arr.forEach((item, i) => {
                        if (item.images_data) {
                            this.getFileDetailFun(item.images_data, i, 'imgData');
                        } else {
                            this.getFileDetailFun('', i, 'imgData');
                        }
                    });
                    this.EngineeringList = res;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 获取单体进度list
        getEngineeringMonomerList() {
            this.$axios
                .get('/interfaceApi/sale/engineering_progress/get_engineering_monomer_list/' + this.detail.engineering_id)
                // .get('/interfaceApi/sale/engineering_progress/get_engineering_monomer_list/92da0a2b-cba4-448e-af53-290ff9e518fe')
                .then(res => {
                    const arr = res;
                    res.forEach(() => {
                        this.imgDataDt.push([]);
                    });
                    arr.forEach((item, i) => {
                        if (item.images_data) {
                            this.getFileDetailFun(item.images_data, i, 'imgDataDt');
                        } else {
                            this.getFileDetailFun('', i, 'imgDataDt');
                        }
                    });
                    this.EngineeringMonomerList = res;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 调整单体进度详情
        hanleClick(val) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'monomerDetails',
                params: {
                    obj: this.detail,
                    active: this.active,
                    emid: val.emid,
                },
            });
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ name: 'contractProgress' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ name: 'contractProgress' });
        },
    },
};
</script>
<style lang="stylus">
.schedule
    height 100%
    .add_btn
        position fixed
        bottom 15rpx
        right 15rpx
        width 40rpx
        height 40rpx
        background rgba(21,119,210,1)
        box-shadow 2px 3px 7px 0px rgba(0, 0, 0, 0.35)
        border-radius 50%
        z-index 99
        color #ffffff
        font-size 16rpx
        line-height 40rpx
        text-align center
    section
        height calc(100% - 45rpx)
        background #F0F0F0
        flex 1
        display flex
        flex-direction column
        header
            background #2b5dab
            padding 5rpx 15rpx 15rpx
            .headerContent
                height 100%
                background 100%
                background #fff
                border-radius 4rpx
                .van-divider
                    margin 0
                div
                    overflow hidden
                .corporateName
                    padding 0 15rpx
                    font-size 12rpx
                    line-height 30rpx
                    color #333333
                    p
                        width calc(100% - 130rpx)
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                        color #000
                    span
                        width 120rpx
                        font-size 10rpx
                        color #979EA7
                .entryName
                    padding 0 15rpx
                    font-size 16rpx
                    color #3495FB
                    border-bottom 1px dashed rgba(215,215,215,1)
                    display flex
                    p
                        font-size 14rpx
                        line-height 22rpx
                        padding 10rpx 0
                        flex 1
                    i
                        font-size 10rpx
                        height 20rpx
                        line-height 20rpx
                        border-radius 10rpx
                        margin 10rpx 0 10rpx 5rpx
                        padding-top 1rpx
                        &.projectObject
                            color #21BDCC
                            background rgba(33, 189, 204, 0.4)
                            width 40rpx
                            text-align center
                        &.projectImportance
                            color #FA8436
                            background rgba(250, 132, 54, 0.4)
                            width 60rpx
                            text-align center
                .squareQuantity
                    padding 0 15rpx
                    height 38rpx
                    position relative
                    &:before
                        content ''
                        position absolute
                        height 15rpx
                        width 1px
                        background #F0F0F0
                        left 50%
                        top 50%
                        transform translateY(-50%)
                    div
                        width 50%
                        font-size 14rpx
                        line-height 36rpx
                        color #979EA7
                        text-align center
                        &:before
                            font-size 16rpx
                            padding-top 2rpx
                        span
                            font-size 16rpx
                            color #3495FB
                            &.estimate
                                color #3495FB
                            &.alreadyUsed
                                color #E60000
                .remarks
                    padding 0 15rpx
                    font-size 10rpx
                    line-height 30rpx
                    color #979EA7
        .section-box
            flex 1
            height 100%
            overflow hidden
            .van-tabs
                height 100%
                .van-tab__text
                    font-size 14rpx
                .van-tabs__content
                    height calc(100% - 44rpx)
                    .van-tab__pane-wrapper
                        height 100%
                        overflow-x hidden
                        overflow-y: scroll;
                        -webkit-overflow-scrolling: touch;
            .no_data
                padding-top 10rpx
                text-align center
                // img
                //     width 100%
                //     // height 10%
            .projectProgress
                .van-steps
                    background none
                .van-step--vertical
                    &:first-child
                        &::before
                            display none
                    .van-step__line
                        width 0
                        border-left 2px dashed #D7D7D7
                        left -16px
                    &:last-child
                        .van-step__line
                            border none
                .van-steps
                    h3
                        overflow hidden
                        margin-bottom 15rpx
                        span
                            color #3495FB
                    .scheduleContant
                        ul
                            overflow hidden
                            li
                                float left
                                border-radius 4rpx
                                margin 0 7rpx 14rpx 7rpx
                                width auto
                                &:nth-child(3n+3)
                                    margin-right 0
                                img
                                    width 100%
                                    height 100%
                        background #ffffff
                        border-radius 4rpx
                        padding 15rpx
                        p
                            font-size 14rpx
                            line-height 22rpx
                            color #333333
                        span
                            display block
                            font-size 10rpx
                            color #979EA7
                            margin-top 10rpx
            .monomerProgress
                height 100%
                overflow hidden
                .monomer-wrapper
                    ul
                        padding 15rpx
                        li
                            border-radius 4rpx
                            overflow hidden
                            background #fff
                            margin-bottom 10rpx
                            h3
                                width 100%
                                font-size 12rpx
                                line-height 30rpx
                                color #979EA7
                                background #FAFAFA
                                padding-left 30rpx
                                border-bottom 1px solid #F0F0F0
                                position relative
                                &::after
                                    content ""
                                    width 10rpx
                                    height 10rpx
                                    border-radius 50%
                                    background rgba(230,0,0,1);
                                    opacity 0.2;
                                    position absolute
                                    top 10rpx
                                    left 0
                                    margin-left 10rpx
                                &::before
                                    content ""
                                    width 5rpx
                                    height 5rpx
                                    border-radius 50%
                                    background rgba(230,0,0,1);
                                    position absolute
                                    top 12.5rpx
                                    left 2.5rpx
                                    margin-left 10rpx
                            .info
                                padding 14rpx 15rpx
                                overflow hidden
                                display flex
                                flex-direction column
                                .header-name
                                    width 100%
                                    margin-bottom 15rpx
                                    vertical-align middle
                                    span
                                        font-size 16rpx
                                        color #000000
                                        vertical-align middle
                                    img
                                        width 18rpx
                                        margin-right 12rpx
                                        vertical-align middle
                                .info-box
                                    display flex
                                    .left_text
                                        flex 1
                                        p
                                            overflow hidden
                                            margin-bottom 15rpx
                                            font-size 14rpx
                                            color #666666
                                            &:last-child
                                                margin-bottom 0
                                            img,span
                                                float left
                                                height 18rpx
                                                line-height 16rpx
                                            img
                                                width 16rpx
                                                margin-right 12rpx
                                    .right_img
                                        height 80rpx
                                        border-radius 4rpx
                            .van-divider
                                margin 0
                            .van-steps
                                .van-step--finish
                                    color #3495FB
                                    .van-step__circle,
                                    .van-step__line
                                        background-color  #3495FB
</style>
